import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function SaveSuccess() {
  return (
    <motion.div
      key="loading"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3, delay: 0 }}
      exit={{ opacity: 0, transition: { duration: 0.2 } }}
    >
      <div className="row my-5">
        <div className="col-sm-8 offset-sm-2">
          <div className="alert alert-success" role="alert">
            <div className="mb-3">
              <h2>
                <i className="bi bi-check-circle text-success me-2"></i> Hasło zostało zmienione
              </h2>
            </div>
            <div>
              <p>Twoje hasło zostało zmienione.</p>
              <p>
              Przy kolejnym logowaniu użyj swojego nowego hasła.
              </p>
              <p><Link to="/" className="alert-link">Wróć do strony głównej</Link></p>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
